import React from "react";
import { FilterServer } from "components/MultiFiltro";

const FiltroBusqueda = ({setFiltros, reset = false, filtroActual}) => {

  let listaFiltros=[];
  const filtrosBusqueda = {
    titulo: "Filtrar por: ",
    data: [
      { id: "colaborador", titulo: "Apellidos y Nombres", tipo: "texto" },
      { id: "documentoIdentidad", titulo: "Documento Identidad", tipo: "texto" },
      { id: "accesoPlataforma", titulo: "Acceso a Plataforma", tipo: "lista" },
      { id: "estado", titulo: "Estado Registro", tipo: "lista" },
     // { id: "tipoDocumento", titulo: "Tipo de Documento", tipo: "lista" },
    ],
  };
   listaFiltros.push({ accesoPlataforma: "SI" });
   listaFiltros.push({ accesoPlataforma: "NO" });
   listaFiltros.push({ estado: "ACTIVO" })
   listaFiltros.push({ estado: "CESADO" })
  //  listaFiltros.push({ tipoDocumento: "DNI" })
  //  listaFiltros.push({ tipoDocumento: "Carnet de Extranjería" })
  //  listaFiltros.push({ tipoDocumento: "Pasaporte" })
   

  const onFiltrar =  (filtrosSeleccionados) => {

    try {

      if(filtroActual!==undefined){
        if(!(Object.entries(filtroActual).length===0 && Object.entries(filtrosSeleccionados).length===0)){
          setFiltros(filtrosSeleccionados)
        }
    }else if(filtroActual===undefined){
      setFiltros(filtrosSeleccionados)
    }
        
    } catch (error) {
      console.error(error);
    } finally {

    }
  };

  return (
    <FilterServer
      placeholder="Haz clic aquí para filtrar los postulantes"
      filtros={filtrosBusqueda}
      onFiltrarDatos={onFiltrar}
      data={listaFiltros}
      reset={reset}
    />
  );
};

export default FiltroBusqueda;
